import React from 'react';
import Navbar from 'react-bootstrap/Navbar';
import { FormattedMessage, injectIntl } from 'react-intl';
import logo from '../assets/images/serty_logo.png';
import { Version } from './Version';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

export interface IMenuNavigationProps {
  activePage: string;
  changePage: (page: string) => void;
  pages: IMenuItem[];
  intl: any;
}

export interface IMenuItem {
  text: string;
  icon: string;
  page: JSX.Element;
}

const MenuNavigation = (props: IMenuNavigationProps) => {

  const buttons: JSX.Element[] = [];
  props.pages.forEach((page: IMenuItem) => {
    const classes = ['nav-link d-flex flex-row align-items-center Menu-Icon'];
    if (page.text === props.activePage) {
      classes.push('active');
    }
    if(page.icon !== '') {
      buttons.push(
        <li className="nav-item" key={page.text}>
          <button
            className={classes.join(' ')}
            onClick={() => props.changePage(page.text)}
            key={page.text}>
            <FontAwesomeIcon icon={page.icon as IconProp} />
            <FormattedMessage id={page.text}/>
          </button>
        </li>
      );
    } else {
      buttons.push(
        <li className="Nav-Header" key={page.text}>
          <FormattedMessage id={page.text}/>
        </li>
      );
    }
  })
  return (
    <div className="LeftPanelWrp">
      <Navbar expand="md" variant="dark">
        <Navbar.Toggle aria-controls="LeftPanelContent" />
        <Navbar.Collapse id="LeftPanelContent">
          <div className="menu-wrp">
            <div className="serty-id">
              <img className="test" src={logo} alt="Sernet - logo - Home page" />
            </div>
            <nav id="main-nav" aria-label="Main navigation">
              <ul className="nav navbar-nav">
                { buttons }
              </ul>
            </nav>
          </div>
          <Version/>
        </Navbar.Collapse>
      </Navbar>
    </div>
  );
}

export default injectIntl(MenuNavigation);
